import { CheckImageIsFile, CheckDataIfExit } from "src/helper/publicFunction";
import { setLoading } from "src/store/customizer/CustomizerSlice";
import { GetFunction } from "src/utils/axios_connection";
import UrlApi from "src/utils/Url";
import { PostFunction } from "src/utils/axios_connection";

export const GetAddresses =
  ({ callback, page, rowsPerPage }) =>
  async (dispatch, getState) => {
    try {
      let link = UrlApi.address.get + `?page=${page}&limit=${rowsPerPage}`;
      const response = await GetFunction({
        data: {},
        Route: link,
        showalert: false,
        state: getState,
        isMultipart: false,
        dispatch: dispatch,
        usersRoute: true,
      });
      callback(response);
    } catch (err) {
      callback(false);
    }
  };

export const DeleteAddress =
  ({ locationId, callback }) =>
  async (dispatch, getState) => {
    try {
      let link = UrlApi.address.delete;
      const response = await GetFunction({
        data: {},
        Route: link + `/${locationId}`,
        showalert: false,
        state: getState,
        isMultipart: false,
        dispatch: dispatch,
        usersRoute: true,
      });
      callback(response);
    } catch (err) {
      callback(false);
    }
  };

export const ManageAddresses =
  ({ callback, values, editMode }) =>
  async (dispatch, getState) => {
    try {
      dispatch(setLoading(true));
      var bodyData = {};
      let paramID = "";
      if (editMode) {
        paramID = values?.id;
      }
      if (CheckDataIfExit(values?.governorate)) {
        bodyData.governorate = values?.governorate?.trim();
      }
      if (CheckDataIfExit(values?.email)) {
        bodyData.email = values?.email?.trim();
      }
      if (CheckDataIfExit(values?.phone1)) {
        bodyData.phone1 = values?.phone1?.trim();
      }
      if (CheckDataIfExit(values?.phone2)) {
        bodyData.phone2 = values?.phone2?.trim();
      }
      if (CheckDataIfExit(values?.location)) {
        bodyData.location = values?.location?.trim();
      }
      if (CheckDataIfExit(values?.embed)) {
        bodyData.embed = values?.embed?.trim();
      }

      const response = await PostFunction({
        data: bodyData,
        Route: editMode
          ? `${UrlApi.address.edit}/${paramID}`
          : UrlApi.address.add,
        showalert: true,
        state: getState,
        isMultipart: false,
        dispatch: dispatch,
        usersRoute: true,
      });
      dispatch(setLoading(false));
      callback(response);
    } catch (err) {
      console.error(err);
      dispatch(setLoading(false));
      callback(false);
    }
  };

export const EditLocations =
  ({ callback, allData, id, nameFailed, dataFailed }) =>
  async (dispatch, getState) => {
    try {
      dispatch(setLoading(true));
      let data;
      if (allData) {
        data = allData;
      } else {
        data = {
          [nameFailed]: dataFailed,
        };
      }
      const response = await PostFunction({
        data,
        Route: UrlApi.address.edit + `/${id}`,
        showalert: true,
        state: getState,
        isMultipart: false,
        dispatch: dispatch,
        usersRoute: true,
      });
      dispatch(setLoading(false));
      callback(response);
    } catch (err) {
      dispatch(setLoading(false));
      callback(false);
    }
  };
